import { RedemptionStepsList, RedemptionStepsItem } from './RedemptionStepsList.styles';

const RedemptionSteps = ({ steps = [], offerId }) => {
  if (!steps.length) {
    return <p>No steps to display</p>;
  }

  return (
    <RedemptionStepsList>
      {steps.map((step, index) => (
        <RedemptionStepsItem key={`${offerId}-${index}`}>{step}</RedemptionStepsItem>
      ))}
    </RedemptionStepsList>
  );
};

export default RedemptionSteps;
